(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-slider"]) return;
  try {
    
 
 var sectionCounter = 0;
 var sections = document.querySelectorAll(".subscription-slide[data-step]");
 var footerData = document.querySelectorAll(".subscription-tile-wrapper[data-step]");
 var footerText = document.querySelectorAll(".subscription-mini-summary__text");
 var summary = document.querySelectorAll(".subscription-tile__text--summary");
 var quantityImages = document.querySelectorAll(".step-two-image");
 var frequencyImages = document.querySelectorAll(".step-three-image");
 var summaryImages = document.querySelectorAll(".step-summary-image");
 
 var prepVariantId = 0;
 var prepSellingPlan = 0;
 
 let flavor = '';
 let qty = '';
 let selling_plan = '';
 
 let subscriptions = {
   original : {
   "1" : { variantId : 41265738645702 },
   "4" : { variantId : 41265738678470 },
   "8" : { variantId : 41265738711238 },
   "7" : { subscriptionPlanId: 774963398 },
   "14" : { subscriptionPlanId: 774996166 },
   "28" : { subscriptionPlanId: 775028934 }
   },
   teriyakee : {
   "1" : { variantId : 41265748869318 },
   "4" : { variantId : 41265748902086 },
   "8" : { variantId : 41265748934854 },
   "7" : { subscriptionPlanId: 774865094 },
   "14" : { subscriptionPlanId: 774897862 },
   "28" : { subscriptionPlanId: 774930630 }
   },
   spicyee : {
   "1" : { variantId : 41807631843526 },
   "4" : { variantId : 41807631876294 },
   "8" : { variantId : 41807631909062 },
   "7" : { subscriptionPlanId: 805306566 },
   "14" : { subscriptionPlanId: 805339334 },
   "28" : { subscriptionPlanId: 805372102 }
   }
 }
 
 function addToCart() {
   data = {
     "id": prepVariantId,
     "quantity": 1,
     "selling_plan": prepSellingPlan
   }
  
   jQuery.ajax({
     type: 'POST',
     url: '/cart/add.js',
     data: data,
     dataType: 'json',
     success: function() { 
     window.location.href = '/cart'; 
     }
   });
 }
 
 gsap.to(sections, {
         autoAlpha: 0,
         x: 100
       })
 
 function init() {
   for (let i = 0; i < sections.length; i++) {
 
     if (sections[i].dataset.step == sectionCounter ) {
       sections[i].setAttribute("aria-hidden", "false");
       // sections[i].style.display = "";
       
       gsap.to(sections[i], {
         autoAlpha: 1,
         x: 0
       })
 
     } else {
       sections[i].setAttribute("aria-hidden", "true");
       // sections[i].style.display = "none";
 
       gsap.to(sections[i], {
         autoAlpha: 0,
         x: 100
       })
 
     }
                                       
     if (sectionCounter > 0 ) { 
	   document.querySelectorAll(".jerkyClubSignUp__startover").forEach(elem => {
         elem.setAttribute("aria-hidden", "false");
         elem.style.display = "";
	   })
     } else {
       document.querySelectorAll(".jerkyClubSignUp__startover").forEach(elem => {
         elem.setAttribute("aria-hidden", "true");
         elem.style.display = "none";
	   })
     }
 
     if (sectionCounter > 2) {
 
       flavor = footerText[0].textContent;
       qty = footerText[1].textContent;
       selling_plan = footerText[2].textContent;
 
       if (subscriptions[flavor]) {
         let tempSubscriptions = subscriptions[flavor];
         prepVariantId = tempSubscriptions[qty].variantId;
         prepSellingPlan = tempSubscriptions[selling_plan].subscriptionPlanId;
       }
       
       summary[i].dataset.reset, summary[i].textContent = footerText[i].textContent;
       //document.querySelector(".jerkyClubSignUp__footer").setAttribute("aria-hidden", "true");
       //document.querySelector(".jerkyClubSignUp__footer").style.display = "none";

	   let newImgTag = document.createElement("img");
       newImgTag.classList = "subscription-tile__image step-summary-image";
       newImgTag.src = summaryImages[i].src;

       var imgDiv = document.getElementById("summaryQuantityImgsUpdate"); 

	   if (summary[i].textContent === "1") {

       		imgDiv.appendChild(newImgTag);

       		while (imgDiv.childNodes.length > 1) {
       			imgDiv.removeChild(imgDiv.childNodes[0]);
       		}

        	for (let k = 0; k < imgDiv.childNodes.length; k++) {
            	imgDiv.childNodes[k].src = summaryImages[i].src;
            }

            imgDiv.className = "subscription-tile__image-container subscription-tile__image-container--1";
                                
        } else if (summary[i].textContent === "4") {

        	for (let j = 0; j < 4; j++) {
        		imgDiv.appendChild(newImgTag.cloneNode(true));
        	}

        	while (imgDiv.childNodes.length > 4) {
        		imgDiv.removeChild(imgDiv.childNodes[0]);
        	}

        	for (let k = 0; k < imgDiv.childNodes.length; k++) {
            	imgDiv.childNodes[k].src = summaryImages[i].src;
            }

            imgDiv.className = "subscription-tile__image-container subscription-tile__image-container--4";

        } else if (summary[i].textContent === "8") {

            for (let j = 0; j < 8; j++) {
        		imgDiv.appendChild(newImgTag.cloneNode(true));
        	}

        	while (imgDiv.childNodes.length > 8) {
        		imgDiv.removeChild(imgDiv.childNodes[0]);
        	}

        	for (let k = 0; k < imgDiv.childNodes.length; k++) {
            	imgDiv.childNodes[k].src = summaryImages[i].src;
            }

            imgDiv.className = "subscription-tile__image-container subscription-tile__image-container--8";
        }
 
       gsap.to(document.querySelector(".jerkyClubSignUp__footer"), {
         autoAlpha: 0,
         x: 100
       })
     }
   }
 }

 //document.querySelector(".jerkyClubSignUp__footer-wrapper").setAttribute("aria-hidden", "true");
 //document.querySelector(".jerkyClubSignUp__footer-wrapper").style.display = "none";
 
 document.querySelectorAll(".subscription-tile__button").forEach( el => {
   el.addEventListener('click', function (e) {
     for (let i = 0; i < footerData.length; i++) {
       if (footerData[i].dataset.step == sectionCounter) {
         footerText[i].dataset.reset = el.dataset.value;
         footerText[i].textContent = el.dataset.value;
                                           
         for (let j = 0; j < quantityImages.length; j++) {
  			quantityImages[j].src = el.querySelector(".subscription-tile__image").src;
  		 }

  		 for (let k = 0; k < frequencyImages.length; k++) {
            frequencyImages[k].src = el.querySelector(".subscription-tile__image").src;
         }

         for (let l = 0; l < summaryImages.length; l++) {
  			summaryImages[l].src = el.querySelector(".subscription-tile__image").src;
  		 }
       }
     }
 
     sectionCounter++;
 
     init();
   })
 });
 
 
 document.querySelectorAll(".jerkyClubSignUp__startover").forEach( elem => {
	elem.addEventListener('click', function (e) {
      sectionCounter = 0;
      init();
	})
 });
                                               
 document.getElementById("add-to-cart-button").addEventListener('click', addToCart);
 
 init();
 
 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yeeyeefest-video"] && !Shopify.designMode) return;
  try {
    
  /* Optional JavaScript for custom video control buttons if used */
  videoAutoplay = () => {
    let elem = document.querySelectorAll('.video__autoplay')

    elem.forEach(elem => {
      let btnMute = elem.querySelector('.autoplay__video-mute'),
          btnUnmute = elem.querySelector('.autoplay__video-unmute'),
          btnRestart = elem.querySelector('.autoplay__video-restart'),
          video = elem.querySelector('.autoplay__video')

      // If there are no custom controls, skip
      if (!btnMute) return

      btnMute.style.display = 'none'

      btnMute.addEventListener('click', ()=> {
        btnMute.style.display = 'none'
        btnUnmute.style.display = 'flex'
        video.muted = true
      })

      btnUnmute.addEventListener('click', ()=> {
        btnMute.style.display = 'flex'
        btnUnmute.style.display = 'none'
        video.muted = false
      })

      btnRestart.addEventListener('click', ()=> {
        video.currentTime = 0
      })
    })
  }

  videoAutoplay()

  } catch(e) { console.error(e); }
})();
})();
